import { RouteComponentProps } from "src/declaration";
import renderClassNights from "./class_nights";
import { PageDataTypeTeaching } from "../../types";

export default function TeachingPage(props: RouteComponentProps) {
  return renderClassNights(
    (props.innerHTML as PageDataTypeTeaching)?.Teaching,
    true
  );
}
